import {postObjectWithApiError, IResultAndError,getObject} from '../../lib/ChoiceApi';
import {NoTzDate} from "../../lib/DateUtils";
import {IMultipleAudit} from './AuditModel';

export const minimum_signing_credential_type = 5;

export enum ApprovalType {
    Pending = 0,
    Completed = 1
}
export enum RxQueueStatus { 
    Denied = 0,
    Pending = 1,
    ReadyToSign = 2,
    Signed = 3,
    SentToPharmacy = 4
};
export enum prescriptionStatusCodes {
    Ineffective = 0,
    AllergicReaction = 1,
    Current	= 2,
    Expired = 3,
    Stopped = 4,
    New	= 5,
    Overdosed = 6,
    DrugInteraction = 7,
    Other = 8,
    NeedsDrApproval	= 9,
    Change = 10,
    Discontinue = 11,
    Renew = 12,
    Hold = 13,
    Error = 14,
    Completed = 15,
    SideEffects = 16,
    DiscontinueFinancial = 17
};
export interface ICredentialSearch {
    credentialID: number,
    credentialTypeID: number
};
export interface IPatientRxQueueSearch {
    patientID: number,
    patientFullName: string,
    birthDate?: NoTzDate,
    gender?: string,
    homePhone?: string,
    workPhone?: string,
    otherPhone?: string,
    patientAddress?: string,
    patientCity?: string,
    patientState?: string,
    patientZipCode?: string,
    rxCount: number
};
export interface IInsuranceSearch {
    coverageLevel: string,
    payerName: string,
    payerPhone?: string
};
export interface IPrescriberSearch {
    prescriberID: number,
    billingProviderID: number,
    npi: string,
    dea?: string,
    providerFullName?: string,
    prescriberLocation: string,
    prescriberAddress: string,
    prescriberCity: string,
    prescriberState: string,
    prescriberZipcode: string,
    providerAccess : number
};
export interface IPrescriptionSearch {
    prescriberID: number,
    prescriptionID: number,
    writtenDateUTC: NoTzDate,
    effectiveDate?: NoTzDate,
    voidAfterDate?: NoTzDate,
    drugName: string,
    scheduleLevel: number,
    fullSig?: string,
    fullDispense?: string,
    dispenseAsWritten?: string,
    refillDescription?: string,
    queueStatusID: RxQueueStatus,
    queueStatusCreation: string,
    rxStatusCode: number,
    pharmacyInformation: string,
    pharmacyPhone?: string,
    pharmacyFax?: string,
    providerFullName? : string,
    drugSeverityLevel? : number,
    allergySeverityLevel? : number,
    diseaseSeverityLevel? : number,
    providerAccess : number
};
export interface IPatientRxQueueResponse {
    credentialData: ICredentialSearch,
    patientData: IPatientRxQueueSearch,
    insuranceList?: IInsuranceSearch[],
    prescriberList?: IPrescriberSearch[],
    prescriptionList?: IPrescriptionSearch[]
};
export interface IPrescriptionStatus {
    PrescriptionID: number,
    QueueStatusID: RxQueueStatus,
    ScheduleLevel: number,
    ProviderAccess: number,
    Interaction: boolean 
};
export interface IQueueUpdates {
    PrescriptionID: number,
    QueueStatusID: RxQueueStatus,
    PrescriptionRxStatusCode: number
};
export interface IQueueAudits {
    QueueRecords: IQueueUpdates[],
    AuditRecords: IMultipleAudit[]
};
export interface IUpdatePrescriptionQueueResult {
    errorCode: number,
    errorMessage?: string 
};
export interface IPrescriptionIds {
    prescriptionId: number
}
export interface SignSendInputs {
    SignSendRecords: IPrescriptionIds[]
}
export interface ISendPrescriptionResult {
    prescriptionID: number,
    errorCode: number,
    prescriptionMessage: string 
}
export interface ISendPrescriptionResponse {
    prescriptionList: ISendPrescriptionResult[]
}
export interface ISignPrescriptionResult {
    prescriptionID: number,
    epcsInformation: string,
    errorCode: number,
    errorMessage: string  
}
export interface ISignPrescriptionResponse {
    prescriptionList: ISignPrescriptionResult[]
}
export async function UpdatePrescriptionQueue(payload: IQueueAudits): Promise<IResultAndError<IUpdatePrescriptionQueueResult>>{
    return postObjectWithApiError("api/Prescriptions/RxQueue/UpdatePrescriptionQueue", payload);
};
export async function SendPrescriptionQueue(payload: SignSendInputs): Promise<IResultAndError<ISendPrescriptionResponse>>{
    return postObjectWithApiError("api/Prescriptions/RxQueue/SendPrescriptionQueue", payload);
};
export async function SignPrescriptionQueue(payload: SignSendInputs): Promise<IResultAndError<ISignPrescriptionResponse>>{
    return postObjectWithApiError("api/Prescriptions/RxQueue/SignPrescriptionQueue", payload);
};
export async function GetPatientRxQueue(patientId : number, patientType : string, completed : number): Promise<IResultAndError<IPatientRxQueueResponse>>{  
    let returnErrorMessage = "";
    const url = `api/Prescriptions/RxQueue/GetPatientRxQueue/${patientId}/${patientType}/${completed}`;
    const responseObject = await getObject<IPatientRxQueueResponse>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? "Unable to retrieve patient information.";
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}